var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ColumnBaseComponent } from '../base/columnbase.component';
import { ColumnService } from '../column/column.service';
import { ConfigService } from '../../../service/config.service';
import { ColumnBaseService } from '../base/columnbase.service';
var FormLinkComponent = /** @class */ (function (_super) {
    __extends(FormLinkComponent, _super);
    function FormLinkComponent(service, baseService, config) {
        var _this = _super.call(this, service, baseService) || this;
        _this.service = service;
        _this.baseService = baseService;
        _this.config = config;
        _this.cacheInvalidateKey = '_';
        _this.cacheInvalidate = '';
        _this.assets = _this.config.config['assets_base'] || '';
        return _this;
    }
    FormLinkComponent.prototype.ngOnInit = function () {
        // super.ngOnInit();
        var cache = jsonpath.value(this.col, '$.params.cache');
        if (this.col.params && this.col.params.cache === false) {
            this.cacheInvalidate = this.updateCacheInvalidate();
        }
        else {
            this.cacheInvalidate = '';
        }
    };
    FormLinkComponent.prototype.ngOnChanges = function () {
        // super.ngOnChanges(changes);
        this.setValue();
    };
    FormLinkComponent.prototype.setValue = function () {
        this.url = this.val;
        var params = (this.col && this.col.params ? this.col.params : {});
        if (typeof params.url !== 'undefined' && !this.col.key) {
            this.url = params.url;
        }
        if (params.assets === true) {
            this.url = this.assets + this.url;
        }
    };
    FormLinkComponent.prototype.onClick = function (e) {
        e.stopPropagation();
    };
    FormLinkComponent.prototype.updateCacheInvalidate = function () {
        this.cacheInvalidate = '?' + this.cacheInvalidateKey + '=' + Date.now();
        return this.cacheInvalidate;
    };
    FormLinkComponent.decorators = [
        { type: Component, args: [{
                    selector: 'column-link',
                    template: "\n        <a *ngIf=\"url\" href=\"{{ url + cacheInvalidate }}\" target=\"_blank\" (click)=\"onClick($event)\" [key]=\"key\" [col]=\"col\" columnDir>{{ col.label || url }}</a>\n        <a *ngIf=\"!url\" href=\"javascript:void(0);\" [key]=\"key\" [col]=\"col\" columnDir>{{ col.label || url }}</a>\n    ",
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    /** @nocollapse */
    FormLinkComponent.ctorParameters = function () { return [
        { type: ColumnService },
        { type: ColumnBaseService },
        { type: ConfigService }
    ]; };
    return FormLinkComponent;
}(ColumnBaseComponent));
export { FormLinkComponent };
//# sourceMappingURL=link.component.js.map